import { ResponsivePie } from '@nivo/pie';
import { tokens } from '@redbax/shared';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';

interface CategoryDonutProps {
  data: Record<string, number>;
  loading?: boolean;
}

export function CategoryDonut({ data, loading }: CategoryDonutProps) {
  if (loading) {
    return (
      <Card>
        <CardHeader>
          <CardTitle className="text-base">Category Breakdown</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex h-[250px] items-center justify-center">
            <div className="h-32 w-32 animate-pulse rounded-full bg-surface-raised" />
          </div>
        </CardContent>
      </Card>
    );
  }

  const chartData = Object.entries(data).map(([label, value], index) => ({
    id: label,
    label,
    value,
    color: tokens.chartColors[index % tokens.chartColors.length],
  }));

  if (chartData.length === 0) {
    return (
      <Card>
        <CardHeader>
          <CardTitle className="text-base">Category Breakdown</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex h-[250px] items-center justify-center text-sm text-text-secondary">
            No detection data available
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">Category Breakdown</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="h-[300px]">
          <ResponsivePie
            data={chartData}
            margin={{ top: 20, right: 20, bottom: 80, left: 20 }}
            innerRadius={0.6}
            padAngle={1}
            cornerRadius={3}
            activeOuterRadiusOffset={8}
            colors={{ datum: 'data.color' }}
            borderWidth={0}
            enableArcLinkLabels={false}
            enableArcLabels={false}
            legends={[
              {
                anchor: 'bottom',
                direction: 'row',
                justify: false,
                translateY: 60,
                itemsSpacing: 8,
                itemWidth: 100,
                itemHeight: 18,
                itemTextColor: tokens.colors.textSecondary,
                symbolSize: 10,
                symbolShape: 'circle',
              },
            ]}
            theme={{
              text: { fill: tokens.colors.textSecondary },
              tooltip: {
                container: {
                  background: tokens.colors.surface,
                  color: tokens.colors.textPrimary,
                  border: `1px solid ${tokens.colors.border}`,
                },
              },
            }}
          />
        </div>
      </CardContent>
    </Card>
  );
}
